// Small wrapper that gives a single icon button a styled hover-label
// tooltip (the shadcn/Radix Tooltip), so icon-only actions read the same
// across the app instead of relying on the browser's native title=.
import React from 'react';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@/components/ui/tooltip';

export default function IconTip({ label, children, side = 'bottom' }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side}>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
